import styled from "styled-components";

export const GalleryContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

export const ScrollWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  gap: 40px;
  padding: 10px 0;
  user-select: none;
`;

export const Thumbnail = styled.img`
  height: 200px;
  width: 200px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;
`;

export const NavButton = styled.button<{ direction: "left" | "right" }>`
  position: absolute;
  top: 50%;
  ${({ direction }) => (direction === "left" ? "left: 5px;" : "right: 5px;")}
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  cursor: pointer;
  z-index: 1;
`;
